module.exports = __webpack_public_path__ + "img/thumbnail_RedPanda_f_normal.9b4fcb30.png";